function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/suggested/close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6h9v185h1a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/close (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/close (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/close",
    style: {
      clipPath: "url(#6h9v185h1a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/close (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/close (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.042 4.457 8.631.179A.109.109 0 0 0 8.548 0H7.457a.223.223 0 0 0-.168.078l-2.96 3.529L1.369.078A.218.218 0 0 0 1.2 0H.109a.109.109 0 0 0-.083.179l3.589 4.278L.026 8.735a.109.109 0 0 0 .083.179H1.2a.223.223 0 0 0 .168-.078l2.96-3.529 2.96 3.529a.219.219 0 0 0 .168.078h1.092a.109.109 0 0 0 .083-.179z",
    transform: "translate(2.666 2.543)",
    style: {
      fill: "#current"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagClose);
export default __webpack_public_path__ + "static/media/tag_close.9e9f429d14579385177b19cb96cf22b4.svg";
export { ForwardRef as ReactComponent };